import {UI, type PartialOptions} from "../../../../stem-core/ui/UIBase";
import {ConfirmationModal} from "../../../../blinkpay/ui/ConfirmationModal";
import {BlinkInputField} from "../../../common/Input";
import {Input, NumberInput, Select, TextArea} from "../../../../stem-core/ui/input/Input";
import {AddContextVariableModalStyle, FormFieldVariableType} from "./AddContextVariableModal";
import {Level} from "../../../../stem-core/ui/Constants";
import {Button} from "../../../../stem-core/ui/button/Button";
import {registerStyle} from "../../../../stem-core/ui/style/Theme";


interface EditContextVariableModalOptions {
    formField?: any;
}

@registerStyle(AddContextVariableModalStyle)
export class EditContextVariableModal extends ConfirmationModal<EditContextVariableModalOptions> {
    declare characterLimitInput: NumberInput;
    declare descriptionInput: TextArea;
    declare keyInput: Input;
    declare typeInput: Select<FormFieldVariableType>;

    confirmButtonDisabled = false;

    getDefaultOptions(): PartialOptions<EditContextVariableModal> {
        return {
            ...super.getDefaultOptions(),
            title: "Edit variable",
            confirmLabel: "Edit",
        };
    }

    getValue() {
        let value: Record<string, any> = {
            key: this.keyInput.getValue(),
            description: this.descriptionInput.getValue(),
            type: this.typeInput.getValue().toString(),
        };
        if (value.type === FormFieldVariableType.TEXT_LINE.toString() && this.characterLimitInput.getValue()) {
            value.characterLimit = Math.trunc(this.characterLimitInput.getValue());
        }
        return value;
    }

    async removeVariable() {
        const confirm = await ConfirmationModal.prompt({
            title: "Remove variable",
            description: "Removing a Panel's variables may have a significant impact on the UI/functionality of the panel. Make sure the variable is not used anymore before removing it.",
        });
        if (confirm) {
            this.resolve("delete");
        }
    }

    render() {
        const {styleSheet} = this;
        const onInputChange = () => {
            formField.key = this.keyInput.getValue();
            formField.description = this.descriptionInput.getValue();
            formField.type = this.typeInput.getValue();
            this.redraw();
        };
        const {formField} = this.options;

        return [
            <BlinkInputField label="Variable name" className={styleSheet.formField}>
                <Input ref="keyInput" onKeyUp={onInputChange} value={formField.key} disabled/>
            </BlinkInputField>,
            <BlinkInputField label="Type" className={styleSheet.formField}>
                <Select ref="typeInput" options={FormFieldVariableType.all()} onChange={onInputChange}
                        value={formField.type} disabled/>
            </BlinkInputField>,
            <BlinkInputField label="Description" className={styleSheet.formField}>
                <TextArea ref="descriptionInput" onKeyUp={onInputChange} style={{minHeight: 100}}
                          value={formField.description || ""}/>
            </BlinkInputField>,
            (this.typeInput?.getValue() === FormFieldVariableType.TEXT_LINE ||
             formField.type === FormFieldVariableType.TEXT_LINE.toString()) ?
                <BlinkInputField label="Character limit" className={styleSheet.formField}>
                    <NumberInput ref="characterLimitInput" value={formField.characterLimit} onKeyUp={onInputChange}/>
                </BlinkInputField> : null,
            <Button label="Remove variable" level={Level.SECONDARY} onClick={() => this.removeVariable()}/>
        ];
    }
}
